// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const red = "#f44336";
const pink = "#e91e63";
const purple = "#9c27b0";
const indigo = "#3f51b5";
const blue = "#2196f3";
const teal = "#009688";
const green = "#4caf50";
const yellow = "#fec60a";
const orange = "#ff9800";
const brown = "#795548";
const grey = "#9e9e9e";
const black = "#424242";

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: orange,
        secondary: grey,
        accent: black,
        error: red,
        warning: orange,
        info: blue,
        success: green,
        red: red,
        pink: pink,
        purple: purple,
        indigo: indigo,
        blue: blue,
        teal: teal,
        green: green,
        yellow: yellow,
        orange: orange,
        brown: brown,
        grey: grey,
      },
    },
  },
});
